import type { ConfidenceTier } from './types';

export const confidenceTiers: ConfidenceTier[] = ['high', 'medium', 'low', 'indicative'];
export const confidenceTierLabels: Record<ConfidenceTier, string> = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  indicative: 'Indicative',
};

/** Accept old saved strings, URL lists and current arrays without changing tier keys. */
export function normalizeConfidenceSelection(value: unknown): ConfidenceTier[] {
  const entries =
    typeof value === 'string' ? value.split(',').map((tier) => tier.trim()) : Array.isArray(value) ? value : [];
  const selected = confidenceTiers.filter((tier) => entries.includes(tier));
  return selected.length === confidenceTiers.length ? [] : selected;
}

export function confidenceSelectionText(value: ConfidenceTier[] = []): string {
  const selected = normalizeConfidenceSelection(value);
  return selected.length === 0
    ? 'All tiers'
    : selected.length === 3
      ? '3 tiers'
      : selected.map((tier) => confidenceTierLabels[tier]).join(', ');
}

export function confidenceSelectionParam(value: unknown): string {
  return normalizeConfidenceSelection(value).join(',') || 'all';
}

export function toggleConfidenceTier(value: ConfidenceTier[], tier: ConfidenceTier): ConfidenceTier[] {
  return normalizeConfidenceSelection(
    value.includes(tier) ? value.filter((entry) => entry !== tier) : [...value, tier],
  );
}
